import z from "zod";

const linearErrorTypeValues = [
  "ENGINEERING_TEAM_NOT_FOUND",
  "TRIAGE_STATUS_NOT_FOUND",
  "COMPLETED_STATE_NOT_FOUND",
  "ISSUE_UPDATE_FAILED",
  "ISSUE_CREATE_FAILED",
  "ISSUE_ID_REPLACED",
] as const;

const linearErrorTypeSchema = z.enum(linearErrorTypeValues);
const LinearErrorType = linearErrorTypeSchema.enum;
type LinearErrorType = z.infer<typeof linearErrorTypeSchema>;

export type LinearErrors =
  | {
      errorType: typeof LinearErrorType.ENGINEERING_TEAM_NOT_FOUND;
      data: { engineeringTeamName: string };
    }
  | {
      errorType: typeof LinearErrorType.TRIAGE_STATUS_NOT_FOUND;
      data: { teamId: string };
    }
  | {
      errorType: typeof LinearErrorType.COMPLETED_STATE_NOT_FOUND;
      data: { teamId: string };
    }
  | {
      errorType: typeof LinearErrorType.ISSUE_UPDATE_FAILED;
      data: { issueIdentifier: string };
    }
  | {
      errorType: typeof LinearErrorType.ISSUE_CREATE_FAILED;
      data: { teamId: string; issueId: string; linearErrorType: string | null; httpStatus: number | null };
    }
  | {
      errorType: typeof LinearErrorType.ISSUE_ID_REPLACED;
      data: { requestedIssueId: string; linearIssueId: string };
    };

export const linearErrorDetails: Record<LinearErrorType, { sentryDescription: string }> = {
  ENGINEERING_TEAM_NOT_FOUND: { sentryDescription: "Engineering team not found in Linear" },
  TRIAGE_STATUS_NOT_FOUND: { sentryDescription: "Triage status not found for Linear team" },
  COMPLETED_STATE_NOT_FOUND: { sentryDescription: "Completed workflow state not found for Linear team" },
  ISSUE_UPDATE_FAILED: { sentryDescription: "Linear issue update returned an unsuccessful payload" },
  ISSUE_CREATE_FAILED: { sentryDescription: "Linear issue creation failed" },
  ISSUE_ID_REPLACED: { sentryDescription: "Linear filed the issue under a different id than requested" },
};
